import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import logo from "../../Assets/logo.png";
import AuthUser from "../../Hooks/authUser";
import AdminDashboardNav from "./AdminDashboardNav";
import { Icon } from "@iconify/react";

const AdminDashboard = () => {
  const { userInfo } = AuthUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col lg:flex-row">
      {/* Mobile Header Bar */}
      <div className="lg:hidden bg-white border-b border-slate-150 px-4 py-3 flex items-center justify-between sticky top-0 z-30 shadow-sm">
        <Link to="/" className="flex items-center">
          <img className="h-8 w-auto" src={logo} alt="logo" />
        </Link>
        <div className="flex items-center gap-3">
          <div className="text-right">
            <p className="text-xs font-bold text-slate-800">{userInfo?.name || "Admin"}</p>
            <p className="text-[9px] text-green-500 font-bold -mt-0.5">Online</p>
          </div>
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="p-2 border border-slate-200 text-slate-600 rounded-xl hover:bg-slate-50 transition"
          >
            <Icon icon={isSidebarOpen ? "solar:close-square-linear" : "solar:hamburger-menu-linear"} className="text-xl" />
          </button>
        </div>
      </div>

      {/* Desktop Sidebar (Sticky left) */}
      <div className="hidden lg:flex lg:flex-shrink-0 w-72 bg-white border-r border-slate-100 p-5 flex-col">
        {/* Logo Section */}
        <div className="pb-6 pt-2 border-b border-slate-100 mb-4">
          <Link to="/" className="flex items-center">
            <img className="h-9 w-auto" src={logo} alt="logo" />
          </Link>
        </div>

        {/* Sidebar NavLinks & Profile Card */}
        <div className="flex-1 overflow-y-auto">
          <AdminDashboardNav />
        </div>
      </div>

      {/* Mobile Sidebar Drawer (Slide-over overlay) */}
      {isSidebarOpen && (
        <div className="relative z-50 lg:hidden" role="dialog" aria-modal="true">
          {/* Backdrop overlay */}
          <div
            onClick={() => setIsSidebarOpen(false)}
            className="fixed inset-0 bg-slate-900/40 backdrop-blur-xs transition-opacity"
          ></div>

          {/* Drawer menu content */}
          <div className="fixed inset-y-0 left-0 flex w-72 bg-white p-5 border-r border-slate-100 flex-col z-50">
            {/* Logo Section */}
            <div className="pb-6 pt-2 flex items-center justify-between border-b border-slate-100 mb-4">
              <Link to="/" className="flex items-center" onClick={() => setIsSidebarOpen(false)}>
                <img className="h-9 w-auto" src={logo} alt="logo" />
              </Link>
              <button
                onClick={() => setIsSidebarOpen(false)}
                className="p-1.5 text-slate-400 hover:text-slate-650 hover:bg-slate-50 rounded-lg transition"
              >
                <Icon icon="solar:close-square-linear" className="text-lg" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto">
              <AdminDashboardNav onClose={() => setIsSidebarOpen(false)} />
            </div>
          </div>
        </div>
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-y-auto">
        {/* Top Header - Desktop only */}
        <div className="hidden lg:flex items-center justify-between bg-white border-b border-slate-100 px-8 py-4 sticky top-0 z-20 shadow-xs">
          <div>
            <h2 className="text-xs font-bold text-slate-400 uppercase tracking-wider">Control Panel</h2>
            <p className="text-sm font-semibold text-slate-800 mt-0.5">Welcome back, Administrator</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right">
              <p className="text-sm font-black text-slate-800 leading-none">{userInfo?.name || "System Admin"}</p>
              <p className="text-[10px] text-green-500 font-bold mt-1">Available</p>
            </div>
            <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 font-bold border border-slate-200">
              <Icon icon="solar:user-bold" className="text-lg" />
            </div>
          </div>
        </div>

        {/* Dynamic page view container */}
        <div className="flex-1 p-4 lg:p-8 max-w-7xl w-full mx-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
